/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-onrequest': {
    width: 16,
    height: 32,
    viewBox: '0 0 16 32',
    data: '<metadata/><g transform="matrix(.7527 0 0 .7527 -3.516 3.769)"><g class="st0"><path pid="0" class="st1" d="M15.8 14.6c.9-.6 1.8-1.2 1.8-2.3 0-1-.8-1.9-2.4-1.9-1.6 0-2.6.7-3.4 1.7l-1.3-1.5c1.1-1.4 2.9-2.3 5-2.3 2.9 0 4.6 1.6 4.6 3.6 0 1.9-1.3 2.9-2.5 3.7-.9.7-1.8 1.2-1.8 2.2 0 .4.2.8.6 1.1l-1.7.6c-.6-.6-.9-1.2-.9-1.9-.1-1.4 1-2.2 2-3zm-.6 6.8c.8 0 1.4.6 1.4 1.4 0 .8-.7 1.4-1.4 1.4s-1.4-.7-1.4-1.4c-.1-.8.6-1.4 1.4-1.4z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-onrequest.js